import { canSetProjectStatus } from '@components/ProjectStatusMenu'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { StatusActions } from '@store/reducers/dashboard/statuses'
import type { ProjectItem } from '@store/reducers/dashboard/types'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { ActionsContent, MenuButton } from './componentns'
import { useProjectActions } from './hooks'

interface Props {
  project: ProjectItem
}

export const ProjectActionsMenu: React.FC<Props> = ({ project }) => {
  const { onClick } = useProjectActions(project)
  const dispatch = useDispatch()
  const onOpen = () => {
    if (canSetProjectStatus(project)) {
      dispatch(
        StatusActions.request({
          projectId: project.id,
          operation: { type: 'load' },
        })
      )
    }
  }

  return (
    <DropdownMenu.Root
      project={project}
      onClick={onClick}
      content={ActionsContent}
    >
      <MenuButton loading={false} onOpen={onOpen} />
    </DropdownMenu.Root>
  )
}
